"use strict";

require("core-js/modules/es.promise.js");
require("core-js/modules/es.weak-map.js");
require("core-js/modules/web.dom-collections.iterator.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.devicesSaga = devicesSaga;
var _effects = require("redux-saga/effects");
var _webSockets = require("../../../shared/api/webSockets");
var _api = require("../../../utils/api");
var _actions = require("../../../utils/actions");
var _user = require("../../user");
var _functions = require("../../../utils/functions");
var devicesTypes = _interopRequireWildcard(require("./types"));
const _excluded = ["socket"],
  _excluded2 = ["socket"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function sagaGetDevices(_ref) {
  let {
    type,
    payload: {
      siteId
    }
  } = _ref;
  return function* () {
    try {
      const token = yield (0, _effects.select)(_user.selectToken);
      const {
        api: apiURL
      } = yield (0, _effects.select)(_user.selectUrls);
      const response = yield (0, _effects.call)(_api.getAPIDevices, {
        prefUrl: apiURL,
        token,
        siteId
      });
      const responseData = yield (0, _effects.call)(() => response.json());
      yield (0, _effects.call)(_functions.throwErrorIfIsNotCondition, response.ok, responseData.message);
      yield (0, _effects.put)((0, _actions.requestSuccess)(type, responseData));
    } catch (error) {
      // eslint-disable-next-line no-console
      yield (0, _effects.call)(() => console.log('catch', error, type));
      yield (0, _effects.put)((0, _actions.requestError)(type, {
        message: error.message
      }));
    }
  }();
}
function sagaGetValues(_ref2) {
  let {
    type,
    payload
  } = _ref2;
  return function* () {
    try {
      const token = yield (0, _effects.select)(_user.selectToken);
      const {
        api: apiURL
      } = yield (0, _effects.select)(_user.selectUrls);
      const response = yield (0, _effects.call)(_api.getAPIValues, {
        prefUrl: apiURL,
        token,
        payload
      });
      const responseData = yield (0, _effects.call)(() => response.json());
      yield (0, _effects.call)(_functions.throwErrorIfIsNotCondition, response.ok, responseData.message);
      yield (0, _effects.put)((0, _actions.requestSuccess)(type, responseData));
    } catch (error) {
      // eslint-disable-next-line no-console
      yield (0, _effects.call)(() => console.log('catch', error, type));
      yield (0, _effects.put)((0, _actions.requestError)(type, {
        message: error.message
      }));
    }
  }();
}
function sagaGetDeviceValues(_ref3) {
  let {
    type,
    payload
  } = _ref3;
  return function* () {
    try {
      const token = yield (0, _effects.select)(_user.selectToken);
      const {
        api: apiURL
      } = yield (0, _effects.select)(_user.selectUrls);
      const response = yield (0, _effects.call)(_api.getAPIDeviceValues, {
        prefUrl: apiURL,
        token,
        payload
      });
      const responseData = yield (0, _effects.call)(() => response.json());
      yield (0, _effects.call)(_functions.throwErrorIfIsNotCondition, response.ok, responseData.message);
      yield (0, _effects.put)((0, _actions.requestSuccess)(type, responseData));
    } catch (error) {
      // eslint-disable-next-line no-console
      yield (0, _effects.call)(() => console.log('catch', error, type));
      yield (0, _effects.put)((0, _actions.requestError)(type, {
        message: error.message
      }));
    }
  }();
}
function sagaGetDeviceValue(_ref4) {
  let {
      type,
      payload: {
        socket
      }
    } = _ref4,
    payload = _objectWithoutProperties(_ref4.payload, _excluded);
  return function* () {
    try {
      while (true) {
        const socketRequest = yield (0, _effects.call)(_webSockets.socketEmitter, {
          method: 'device',
          socket,
          payload
        });
        const response = yield (0, _effects.take)(socketRequest);
        yield (0, _effects.call)(_functions.throwErrorIfIsNotCondition, Boolean(response === null || response === void 0 ? void 0 : response.data), 'Empty response data');
        const responseData = yield (0, _effects.call)(() => JSON.parse(response.data));
        yield (0, _effects.put)((0, _actions.requestSuccess)(type, responseData));
      }
    } catch (error) {
      yield (0, _effects.call)(() => console.log('catch', error, type));
      yield (0, _effects.put)((0, _actions.requestError)(type, {
        message: error.message
      }));
    }
  }();
}
function sagaGetValue(_ref5) {
  let {
      type,
      payload: {
        socket
      }
    } = _ref5,
    payload = _objectWithoutProperties(_ref5.payload, _excluded2);
  return function* () {
    try {
      while (true) {
        const socketRequest = yield (0, _effects.call)(_webSockets.socketEmitter, {
          method: 'equipment',
          socket,
          payload
        });
        const response = yield (0, _effects.take)(socketRequest);
        yield (0, _effects.call)(_functions.throwErrorIfIsNotCondition, Boolean(response === null || response === void 0 ? void 0 : response.data), 'Empty response data');
        const responseData = yield (0, _effects.call)(() => JSON.parse(response.data));
        yield (0, _effects.put)((0, _actions.requestSuccess)(type, responseData));
      }
    } catch (error) {
      yield (0, _effects.call)(() => console.log('catch', error, type));
      yield (0, _effects.put)((0, _actions.requestError)(type, {
        message: error.message
      }));
    }
  }();
}
function* devicesSaga() {
  yield (0, _effects.all)([(0, _effects.takeLatest)(devicesTypes.GET_DEVICES, sagaGetDevices), (0, _effects.takeEvery)(devicesTypes.GET_VALUE, sagaGetValue), (0, _effects.takeLatest)(devicesTypes.GET_VALUES, sagaGetValues), (0, _effects.takeLatest)(devicesTypes.GET_DEVICE_VALUES, sagaGetDeviceValues), (0, _effects.takeEvery)(devicesTypes.GET_DEVICE_VALUE, sagaGetDeviceValue)]);
}